<template>
  <div>
    <b-card>
      <b-row>
        <b-col class="col-lg-2 col-md-3 col-12">
          <b-form-group :label="$t('general.report_date')">
            <VueDataPicker
              v-model="firstPayment"
              :other-props="{ 'is-range': true }"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div style="overflow-x: auto">
        <table class="table">
          <thead class="center-th">
            <tr>
              <th rowspan="4">
                {{ $t("general.object_name") }}
              </th>
              <th colspan="8">
                {{ $t("general.clients_paid") }}
              </th>
            </tr>
            <tr>
              <th
                scope="col"
                colspan="2"
                rowspan="2"
              >
                {{ $t("general.last") }}
              </th>
              <th
                scope="col"
                colspan="6"
              >
                {{ $t("general.from_them") }}
              </th>
            </tr>
            <tr>
              <th
                scope="col"
                colspan="2"
              >
                {{ $t("objects.bank") }}
              </th>
              <th
                scope="col"
                colspan="2"
              >
                {{ $t("general.report") }}
              </th>
              <th
                scope="col"
                colspan="2"
              >
                {{ $t("clients.barter") }}
              </th>
            </tr>
            <tr>
              <th scope="col">
                {{ $t("general.numbers_room") }}
              </th>
              <th scope="col">
                {{ $t("general.price") }}
              </th>
              <th scope="col">
                {{ $t("general.numbers_room") }}
              </th>
              <th scope="col">
                {{ $t("general.price") }}
              </th>
              <th scope="col">
                {{ $t("general.numbers_room") }}
              </th>
              <th scope="col">
                {{ $t("general.price") }}
              </th>
              <th scope="col">
                {{ $t("general.numbers_room") }}
              </th>
              <th scope="col">
                {{ $t("general.price") }}
              </th>
            </tr>
          </thead>
          <tbody class="center-td">
            <tr
              v-for="item in GET_ALL_CLIENTS_TABLE"
              :key="item.id"
            >
              <td>{{ item.title }}</td>
              <td>{{ item.total_transactions_count }}</td>
              <td>{{ $_moneyFormatter(item.total_transactions_amount) }}</td>
              <td>{{ item.total_cash_transactions_count }}</td>
              <td>
                {{ $_moneyFormatter(item.total_cash_transactions_amount) }}
              </td>
              <td>{{ item.total_noncash_transactions_count }}</td>
              <td>
                {{ $_moneyFormatter(item.total_noncash_transactions_amount) }}
              </td>
              <td>{{ item.total_barter_transactions_count }}</td>
              <td>
                {{ $_moneyFormatter(item.total_barter_transactions_amount) }}
              </td>
            </tr>
            <tr style="background-color: #f3f2f7">
              <td>
                {{ $t('general.last') }}
              </td>
              <td>{{ totalTransactionsCount }}</td>
              <td>{{ $_moneyFormatter(totalTransactionsAmount) }}</td>
              <td>{{ cashTransactionsCount }}</td>
              <td>{{ $_moneyFormatter(cashTransactionsAmount) }}</td>
              <td>{{ noncashTransactionsCount }}</td>
              <td>{{ $_moneyFormatter(noncashTransactionsAmount) }}</td>
              <td>{{ barterTransactionsCount }}</td>
              <td>{{ $_moneyFormatter(barterTransactionsAmount) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>

    <b-card>
      <b-row>
        <b-col class="col-lg-2 col-md-3 col-12">
          <b-form-group :label="$t('general.report_date')">
            <VueDataPicker
              v-model="secondPayment"
              :other-props="{ 'is-range': true }"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div style="overflow-x: auto">
        <table class="table">
          <thead class="center-th">
            <tr>
              <th rowspan="3">
                {{ $t("general.object_name") }}
              </th>
              <th colspan="6">
                {{ $t('general.clients_paid') }}
              </th>
            </tr>
            <tr>
              <th
                scope="col"
                colspan="2"
              >
                {{ $t("general.last") }}
              </th>
              <th
                scope="col"
                colspan="2"
              >
                {{ $t("navbars.sales") }}
              </th>
              <th
                scope="col"
                colspan="2"
              >
                {{ $t("clients.debtor") }}
              </th>
            </tr>
            <tr>
              <th scope="col">
                {{ $t("general.numbers_room") }}
              </th>
              <th scope="col">
                {{ $t("general.price") }}
              </th>
              <th scope="col">
                {{ $t("general.numbers_room") }}
              </th>
              <th scope="col">
                {{ $t("general.price") }}
              </th>
              <th scope="col">
                {{ $t("general.numbers_room") }}
              </th>
              <th scope="col">
                {{ $t("general.price") }}
              </th>
            </tr>
          </thead>
          <tbody class="center-td">
            <tr
              v-for="item in GET_ALL_CLIENTS_BY_INCOME"
              :key="item.id"
            >
              <td>{{ item.title }}</td>
              <td>{{ item.total_transactions_count }}</td>
              <td>{{ $_moneyFormatter(item.total_transactions_amount) }}</td>
              <td>{{ item.total_sale_transactions_count }}</td>
              <td>
                {{ $_moneyFormatter(item.total_sale_transactions_amount) }}
              </td>
              <td>{{ item.total_debtor_transactions_count }}</td>
              <td>
                {{ $_moneyFormatter(item.total_debtor_transactions_amount) }}
              </td>
            </tr>
            <tr style="background-color: #f3f2f7">
              <td>
                {{ $t('general.last') }}
              </td>
              <td>{{ transactionsCount }}</td>
              <td>{{ $_moneyFormatter(transactionsAmount) }}</td>
              <td>{{ saleTransactionsCount }}</td>
              <td>{{ $_moneyFormatter(saleTransactionsAmount) }}</td>
              <td>{{ debtorTransactionsCount }}</td>
              <td>{{ $_moneyFormatter(debtorTransactionsAmount) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
  BCard,
  BSpinner,
  BTr,
  BTh,
  BTable,
  BRow,
  BCol,
  BFormGroup,
} from 'bootstrap-vue'
import formatters from '@/mixins/extra'
import VueDataPicker from '@/components/VueDatePicker.vue'

export default {
  components: {
    BCard,
    BRow,
    VueDataPicker,
    BCol,
    BFormGroup,
    BTable,
    BSpinner,
    BTr,
    BTh,
  },
  mixins: [formatters],

  data() {
    return {
      loader: false,
      firstPayment: null,
      secondPayment: null,
      paramsFirst: {
        from_date: null,
        to_date: null,
      },
      paramsSecond: {
        from_date: null,
        to_date: null,
      },

      fields: [
        {
          key: 'id',
          label: 'ID',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'title',
          label: 'Obyekt nomi',
        },
        {
          key: 'total_flat_count',
          label: 'Soni',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_flat_area',
          label: 'm2',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_sold_flat_count',
          label: 'Soni',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_sold_flat_area',
          label: 'm2',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
    }
  },
  watch: {
    firstPayment(val) {
      this.paramsFirst.from_date = val?.start
      this.paramsFirst.to_date = val?.end
      this.FETCH_ALL_CLIENTS_TABLE(this.paramsFirst)
    },
    secondPayment(val) {
      this.paramsSecond.from_date = val?.start
      this.paramsSecond.to_date = val?.end
      this.FETCH_ALL_CLIENTS_BY_INCOME(this.paramsSecond)
    },
  },
  computed: {
    ...mapGetters('objects', [
      'GET_REPORTS_TABLE',
      'GET_ALL_CLIENTS_TABLE',
      'GET_ALL_CLIENTS_BY_INCOME',
    ]),
    totalTransactionsCount() {
      const data = this.GET_ALL_CLIENTS_TABLE.map(item => item.total_transactions_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalTransactionsAmount() {
      const data = this.GET_ALL_CLIENTS_TABLE.map(item => item.total_transactions_amount)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    cashTransactionsCount() {
      const data = this.GET_ALL_CLIENTS_TABLE.map(item => item.total_cash_transactions_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    cashTransactionsAmount() {
      const data = this.GET_ALL_CLIENTS_TABLE.map(item => item.total_cash_transactions_amount)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    noncashTransactionsCount() {
      const data = this.GET_ALL_CLIENTS_TABLE.map(item => item.total_noncash_transactions_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    noncashTransactionsAmount() {
      const data = this.GET_ALL_CLIENTS_TABLE.map(item => item.total_noncash_transactions_amount)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    barterTransactionsCount() {
      const data = this.GET_ALL_CLIENTS_TABLE.map(item => item.total_barter_transactions_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    barterTransactionsAmount() {
      const data = this.GET_ALL_CLIENTS_TABLE.map(item => item.total_barter_transactions_amount)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    transactionsCount() {
      const data = this.GET_ALL_CLIENTS_BY_INCOME.map(item => item.total_transactions_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    transactionsAmount() {
      const data = this.GET_ALL_CLIENTS_BY_INCOME.map(item => item.total_transactions_amount)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    saleTransactionsCount() {
      const data = this.GET_ALL_CLIENTS_BY_INCOME.map(item => item.total_sale_transactions_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    saleTransactionsAmount() {
      const data = this.GET_ALL_CLIENTS_BY_INCOME.map(item => item.total_sale_transactions_amount)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    debtorTransactionsCount() {
      const data = this.GET_ALL_CLIENTS_BY_INCOME.map(item => item.total_debtor_transactions_count)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    debtorTransactionsAmount() {
      const data = this.GET_ALL_CLIENTS_BY_INCOME.map(item => item.total_debtor_transactions_amount)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
  },

  mounted() {
    this.FETCH_ALL_CLIENTS_TABLE()
    this.FETCH_ALL_CLIENTS_BY_INCOME()
    // this.FETCH_REPORTS_TABLE().then(() => {
    //   this.loader = false;
    // });
  },

  methods: {
    ...mapActions('objects', [
      'FETCH_REPORTS_TABLE',
      'FETCH_ALL_CLIENTS_TABLE',
      'FETCH_ALL_CLIENTS_BY_INCOME',
    ]),
  },
}
</script>

<style>
table,
th,
th {
  border: 1px solid #ccc !important;
}
.bg-warning {
  background: #fefe00 !important;
}

table {
  border: 0px solid red !important;
}

td {
  white-space: nowrap;
}

.text-center {
  text-align: center !important;
}

.center-th th {
  vertical-align: middle !important;
  text-align: center !important;
}
.center-td td {
  vertical-align: middle !important;
  text-align: center !important;
}
</style>
